"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const compare_versions_1 = require("compare-versions");
const EventEmitter_1 = __importDefault(require("./EventEmitter"));
const i18n_1 = __importDefault(require("./i18n"));
const AriForm_1 = require("./AriForm");
const Components_1 = __importDefault(require("./components/Components"));
const NestedDataComponent_1 = __importDefault(require("./components/_classes/nesteddata/NestedDataComponent"));
const AriFormUtils = __importStar(require("./utils/utils"));
const utils_1 = require("./utils/utils");
const formUtils_1 = require("./utils/formUtils");
//Simple
const utils_2 = require("./utils/utils");
//End Simple
// We need this here because dragula pulls in CustomEvent class that requires global to exist.
if (typeof window !== 'undefined' && typeof window.global === 'undefined') {
    window.global = window;
}
const dragula_1 = __importDefault(require("dragula"));
// Initialize the available forms.
AriForm_1.AriForm.forms = {};
// Allow people to register components.
AriForm_1.AriForm.registerComponent = Components_1.default.setComponent;
/**
 *
 * @param {any} icons  - The icons to use.
 * @returns {any} - The icon set.
 */
function getIconSet(icons) {
    if (icons === "fontawesome") {
        return "fa";
    }
    return icons || "";
}
/**
 *
 * @param {any} options - The options to get.
 * @returns {any} - The options.
 */
function getOptions(options) {
    options = lodash_1.default.defaults(options, {
        submitOnEnter: false,
        iconset: getIconSet(options && options.icons ? options.icons : AriForm_1.AriForm.icons),
        i18next: null,
        saveDraft: false,
        alwaysDirty: false,
        saveDraftThrottle: 5000,
        display: "form",
        cdnUrl: AriForm_1.AriForm.cdn.baseUrl,
    });
    if (!options.events) {
        options.events = new EventEmitter_1.default();
    }
    return options;
}
/**
 * Represents a JSON value.
 * @typedef {(string | number | boolean | null | JSONArray | JSONObject)} JSON
 */
/**
 * Represents a JSON array.
 * @typedef {Array<JSON>} JSONArray
 */
/**
 * Represents a JSON object.
 * @typedef {{[key: string]: JSON}} JSONObject
 */
/**
 * @typedef {object} AriFormHooks
 * @property {Function} [beforeSubmit] - A function that is called before the form is submitted.
 * @property {Function} [beforeCancel] - A function that is called before the form is canceled.
 * @property {Function} [beforeNext] - A function that is called before moving to the next page in a multi-page form.
 * @property {Function} [beforePrev] - A function that is called before moving to the previous page in a multi-page form.
 * @property {Function} [attachComponent] - A function that is called when a component is attached to the form.
 * @property {Function} [setDataValue] - A function that is called when setting the value of a data component.
 * @property {Function} [addComponents] - A function that is called when adding multiple components to the form.
 * @property {Function} [addComponent] - A function that is called when adding a single component to the form.
 * @property {Function} [customValidation] - A function that is called for custom validation of the form.
 * @property {Function} [attachWebform] - A function that is called when attaching a webform to the form.
 */
/**
 * @typedef {object} SanitizeConfig
 * @property {string[]} [addAttr] - The attributes to add.
 * @property {string[]} [addTags] - The tags to add.
 * @property {string[]} [allowedAttrs] - The allowed attributes.
 * @property {string[]} [allowedTags] - The allowed tags.
 * @property {string[]} [allowedUriRegex] - The allowed URI regex.
 * @property {string[]} [addUriSafeAttr] - The URI safe attributes.
 */
/**
 * @typedef {object} ButtonSettings
 * @property {boolean} [showPrevious] - Show the "Previous" button.
 * @property {boolean} [showNext] - Show the "Next" button.
 * @property {boolean} [showCancel] - Show the "Cancel" button.
 * @property {boolean} [showSubmit] - Show the "Submit" button.
 */
/**
 * @typedef {object} FormOptions
 * @property {boolean} [saveDraft] - Enable the save draft feature.
 * @property {number} [saveDraftThrottle] - The throttle for the save draft feature.
 * @property {boolean} [readOnly] - Set this form to readOnly.
 * @property {boolean} [noAlerts] - Disable the alerts dialog.
 * @property {{[key: string]: string}} [i18n] - The translation file for this rendering.
 * @property {string} [template] - Custom logic for creation of elements.
 * @property {boolean} [noDefaults] - Exclude default values from the settings.
 * @property {any} [fileService] - The file service for this form.
 * @property {EventEmitter} [events] - The EventEmitter for this form.
 * @property {string} [language] - The language to render this form in.
 * @property {{[key: string]: string}} [i18next] - The i18next configuration for this form.
 * @property {boolean} [viewAsHtml] - View the form as raw HTML.
 * @property {'form' | 'html' | 'flat' | 'builder' | 'pdf'} [renderMode] - The render mode for this form.
 * @property {boolean} [highlightErrors] - Highlight any errors on the form.
 * @property {string} [componentErrorClass] - The error class for components.
 * @property {any} [templates] - The templates for this form.
 * @property {string} [iconset] - The iconset for this form.
 * @property {import('@ariform/core').Component[]} [components] - The components for this form.
 * @property {{[key: string]: boolean}} [disabled] - Disabled components for this form.
 * @property {boolean} [showHiddenFields] - Show hidden fields.
 * @property {{[key: string]: boolean}} [hide] - Hidden components for this form.
 * @property {{[key: string]: boolean}} [show] - Components to show for this form.
 * @property {AriForm} [ariform] - The AriForm instance for this form.
 * @property {string} [decimalSeparator] - The decimal separator for this form.
 * @property {string} [thousandsSeparator] - The thousands separator for this form.
 * @property {AriFormHooks} [hooks] - The hooks for this form.
 * @property {boolean} [alwaysDirty] - Always be dirty.
 * @property {boolean} [skipDraftRestore] - Skip restoring a draft.
 * @property {'form' | 'wizard' | 'pdf'} [display] - The display for this form.
 * @property {string} [cdnUrl] - The CDN url for this form.
 * @property {boolean} [flatten] - Flatten the form.
 * @property {boolean} [sanitize] - Sanitize the form.
 * @property {SanitizeConfig} [sanitizeConfig] - The sanitize configuration for this form.
 * @property {ButtonSettings} [buttonSettings] - The button settings for this form.
 * @property {object} [breadcrumbSettings] - The breadcrumb settings for this form.
 * @property {boolean} [allowPrevious] - Allow the previous button (for Wizard forms).
 * @property {string[]} [wizardButtonOrder] - The order of the buttons (for Wizard forms).
 * @property {boolean} [showCheckboxBackground] - Show the checkbox background.
 * @property {boolean} [inputsOnly] - Only show inputs in the form and no labels.
 * @property {boolean} [building] - If we are in the process of building the form.
 * @property {number} [zoom] - The zoom for PDF forms.
 */
class Webform extends NestedDataComponent_1.default {
    /**
     * Creates a new Form instance.
     * @param {HTMLElement | object | import('Form').FormOptions} [elementOrOptions] - The DOM element to render this form within or the options to create this form instance.
     * @param {import('Form').FormOptions} [options] - The options to create a new form instance.
     */
    constructor(elementOrOptions, options = undefined) {
        let element, formOptions;
        if (elementOrOptions instanceof HTMLElement || options) {
            element = elementOrOptions;
            formOptions = options || {};
        }
        else {
            formOptions = elementOrOptions || {};
        }
        super(null, getOptions(formOptions));
        this.executeShortcuts = (event) => {
            const { target } = event;
            if (!this.keyboardCatchableElement(target)) {
                return;
            }
            const ctrl = event.ctrlKey || event.metaKey;
            const keyCode = event.keyCode;
            let char = "";
            if (65 <= keyCode && keyCode <= 90) {
                char = String.fromCharCode(keyCode);
            }
            else if (keyCode === 13) {
                char = "Enter";
            }
            else if (keyCode === 27) {
                char = "Esc";
            }
            lodash_1.default.each(this.shortcuts, (shortcut) => {
                if (shortcut.ctrl && !ctrl) {
                    return;
                }
                if (shortcut.shortcut === char) {
                    shortcut.element.click();
                    event.preventDefault();
                }
            });
        };
        this.setElement(element);
        // Keep track of all available forms globally.
        AriForm_1.AriForm.forms[this.id] = this;
        // Set the base url.
        if (this.options.baseUrl) {
            AriForm_1.AriForm.setBaseUrl(this.options.baseUrl);
        }
        /**
         * The type of this element.
         * @type {string}
         */
        this.type = "form";
        this._src = "";
        this._loading = false;
        this._form = {};
        this.draftEnabled = false;
        this.savingDraft = false;
        if (this.options.saveDraftThrottle) {
            this.triggerSaveDraft = lodash_1.default.throttle(this.saveDraft.bind(this), this.options.saveDraftThrottle);
        }
        else {
            this.triggerSaveDraft = this.saveDraft.bind(this);
        }
        /**
         * Determines if this form should submit the API on submit.
         * @type {boolean}
         */
        this.nosubmit = false;
        /**
         * Determines if the form has tried to be submitted, error or not.
         * @type {boolean}
         */
        this.submitted = false;
        /**
         * Determines if the form is being submitted at the moment.
         * @type {boolean}
         */
        this.submitting = false;
        /**
         * The AriForm instance for this form.
         * @type {AriForm}
         */
        this.ariform = null;
        /**
         * The loader HTML element.
         * @type {HTMLElement}
         */
        this.loader = null;
        /**
         * The alert HTML element
         * @type {HTMLElement}
         */
        this.alert = null;
        /**
         * Promise that is triggered when the submission is done loading.
         * @type {Promise}
         */
        this.onSubmission = null;
        /**
         * Determines if this submission is explicitly set.
         * @type {boolean}
         */
        this.submissionSet = false;
        /**
         * Promise that executes when the form is ready and rendered.
         * @type {Promise}
         * @example
         * import Webform from '@ariform/js/Webform';
         * let form = new Webform(document.getElementById('ariform'));
         * form.formReady.then(() => {
         *   console.log('The form is ready!');
         * });
         * form.src = 'https://examples.ari.form/example';
         */
        this.formReady = new Promise((resolve, reject) => {
            /**
             * Called when the formReady state of this form has been resolved.
             * @type {Function}
             */
            this.formReadyResolve = resolve;
            /**
             * Called when this form could not load and is rejected.
             * @type {Function}
             */
            this.formReadyReject = reject;
        });
        /**
         * Promise that executes when the submission is ready and rendered.
         * @type {Promise}
         * @example
         * import Webform from '@ariform/js/Webform';
         * let form = new Webform(document.getElementById('ariform'));
         * form.submissionReady.then(() => {
         *   console.log('The submission is ready!');
         * });
         * form.src = 'https://examples.ari.form/example/submission/234234234234234243';
         */
        this.submissionReady = new Promise((resolve, reject) => {
            /**
             * Called when the formReady state of this form has been resolved.
             * @type {Function}
             */
            this.submissionReadyResolve = resolve;
            /**
             * Called when this form could not load and is rejected.
             * @type {Function}
             */
            this.submissionReadyReject = reject;
        });
        this.shortcuts = [];
        // Set language after everything is established.
        this.language = this.i18next.language;
        // See if we need to restore the draft from a user.
        if (this.options.saveDraft) {
            if (this.options.skipDraftRestore) {
                this.draftEnabled = true;
                this.savingDraft = false;
            }
            else {
                this.formReady.then(() => {
                    const user = AriForm_1.AriForm.getUser();
                    // Only restore a draft if the submission isn't explicitly set.
                    if (user && !this.submissionSet) {
                        this.restoreDraft(user._id);
                    }
                });
            }
        }
        this.component.clearOnHide = false;
        // Ensure the root is set to this component.
        this.root = this;
        this.localRoot = this;
        this.root.dragulaLib = dragula_1.default;
    }
    /* eslint-enable max-statements */
    get language() {
        return this.options.language;
    }
    get emptyValue() {
        return null;
    }
    componentContext() {
        return this._data;
    }
    /**
     * Sets the language for this form.
     * @param {string} lang - The language to use (e.g. 'en', 'sp', etc.)
     */
    set language(lang) {
        if (!this.i18next) {
            return;
        }
        this.options.language = lang;
        if (this.i18next.language === lang) {
            return;
        }
        this.i18next.changeLanguage(lang, (err) => {
            if (err) {
                return;
            }
            this.rebuild();
            this.emit("languageChanged");
        });
    }
    get componentComponents() {
        return this.form.components;
    }
    get shadowRoot() {
        return this.options.shadowRoot;
    }
    /**
     * Add a language for translations
     * @param {string} code - The language code for the language being added.
     * @param {object} lang - The language translations.
     * @param {boolean} [active] - If this language should be set as the active language.
     */
    addLanguage(code, lang, active = false) {
        if (this.i18next) {
            var translations = lodash_1.default.assign((0, utils_1.fastCloneDeep)(i18n_1.default.resources.en.translation), lang);
            this.i18next.addResourceBundle(code, "translation", translations, true, true);
            if (active) {
                this.language = code;
            }
        }
    }
    keyboardCatchableElement(element) {
        if (element.nodeName === "TEXTAREA") {
            return false;
        }
        if (element.nodeName === "INPUT") {
            return ["text", "email", "password"].indexOf(element.type) === -1;
        }
        return true;
    }
    addShortcut(element, shortcut) {
        if (!shortcut || !/^([A-Z]|Enter|Esc)$/i.test(shortcut)) {
            return;
        }
        shortcut = lodash_1.default.capitalize(shortcut);
        if (shortcut === "Enter" || shortcut === "Esc") {
            // Restrict Enter and Esc only for buttons
            if (element.tagName !== "BUTTON") {
                return;
            }
            this.shortcuts.push({
                shortcut,
                element,
            });
        }
        else {
            this.shortcuts.push({
                ctrl: true,
                shortcut,
                element,
            });
        }
    }
    removeShortcut(element, shortcut) {
        if (!shortcut || !/^([A-Z]|Enter|Esc)$/i.test(shortcut)) {
            return;
        }
        lodash_1.default.remove(this.shortcuts, {
            shortcut,
            element,
        });
    }
    /**
     * Get the embed source of the form.
     * @returns {string} - The source of the form.
     */
    get src() {
        return this._src;
    }
    /**
     * Loads the submission if applicable.
     * @returns {Promise} - The promise that is triggered when the submission is loaded.
     */
    loadSubmission() {
        this.loadingSubmission = true;
        if (this.ariform.submissionId) {
            this.onSubmission = this.ariform
                .loadSubmission()
                .then((submission) => this.setSubmission(submission), (err) => this.submissionReadyReject(err))
                .catch((err) => this.submissionReadyReject(err));
        }
        else {
            this.submissionReadyResolve();
        }
        return this.submissionReady;
    }
    /**
     * Set the src of the form renderer.
     * @param {string} value - The source value to set.
     * @param {any} options - The options to set.
     * @returns {Promise} - The promise that is triggered when the form is set.
     */
    setSrc(value, options) {
        if (this.setUrl(value, options)) {
            this.nosubmit = false;
            return this.ariform
                .loadForm({ params: { live: 1 } })
                .then((form) => {
                const setForm = this.setForm(form);
                this.loadSubmission();
                return setForm;
            })
                .catch((err) => {
                this.formReadyReject(err);
            });
        }
        return Promise.resolve();
    }
    /**
     * Set the Form source, which is typically the Ari.Form embed URL.
     * @param {string} value - The value of the form embed url.
     * @example
     * import Webform from '@ariform/js/Webform';
     * let form = new Webform(document.getElementById('ariform'));
     * form.formReady.then(() => {
     *   console.log('The form is formReady!');
     * });
     * form.src = 'https://examples.ari.form/example';
     */
    set src(value) {
        this.setSrc(value);
    }
    /**
     * Get the embed source of the form.
     * @returns {string} - returns the source of the form.
     */
    get url() {
        return this._src;
    }
    /**
     * Sets the url of the form renderer.
     * @param {string} value - The value to set the url to.
     * @param {any} options - The options to set.
     * @returns {boolean} - TRUE means the url was set, FALSE otherwise.
     */
    setUrl(value, options) {
        if (!value || typeof value !== "string" || value === this._src) {
            return false;
        }
        this._src = value;
        this.nosubmit = true;
        this.ariform = this.options.ariform = new AriForm_1.AriForm(value, options);
        if (this.type === "form") {
            // Set the options source so this can be passed to other components.
            this.options.src = value;
        }
        return true;
    }
    /**
     * Set the form source but don't initialize the form and submission from the url.
     * @param {string} value - The value of the form embed url.
     */
    set url(value) {
        this.setUrl(value);
    }
    /**
     * Called when both the form and submission have been loaded.
     * @returns {Promise} - The promise to trigger when both form and submission have loaded.
     */
    get ready() {
        return this.formReady.then(() => {
            return super.ready.then(() => {
                return this.loadingSubmission ? this.submissionReady : true;
            });
        });
    }
    /**
     * Returns if this form is loading.
     * @returns {boolean} - TRUE means the form is loading, FALSE otherwise.
     */
    get loading() {
        return this._loading;
    }
    /**
     * Set the loading state for this form, and also show the loader spinner.
     * @param {boolean} loading - If this form should be "loading" or not.
     */
    set loading(loading) {
        if (this._loading !== loading) {
            this._loading = loading;
            if (!this.loader && loading) {
                this.loader = this.ce("div", {
                    class: "loader-wrapper",
                });
                const spinner = this.ce("div", {
                    class: "loader text-center",
                });
                this.loader.appendChild(spinner);
            }
            /* eslint-disable max-depth */
            if (this.loader) {
                try {
                    if (loading) {
                        this.prependTo(this.loader, this.wrapper);
                    }
                    else {
                        this.removeChildFrom(this.loader, this.wrapper);
                    }
                }
                catch (err) {
                    // ingore
                }
            }
            /* eslint-enable max-depth */
        }
    }
    /**
     * Sets the JSON schema for the form to be rendered.
     * @example
     * import Webform from '@ariform/js/Webform';
     * let form = new Webform(document.getElementById('ariform'));
     * form.setForm({
     *   components: [
     *     {
     *       type: 'textfield',
     *       key: 'firstName',
     *       label: 'First Name',
     *       placeholder: 'Enter your first name.',
     *       input: true
     *     },
     *     {
     *       type: 'textfield',
     *       key: 'lastName',
     *       label: 'Last Name',
     *       placeholder: 'Enter your last name',
     *       input: true
     *     },
     *     {
     *       type: 'button',
     *       action: 'submit',
     *       label: 'Submit',
     *       theme: 'primary'
     *     }
     *   ]
     * });
     * @param {object} form - The JSON schema of the form @see https://examples.ari.form/example for an example JSON schema.
     * @param {any} flags - Any flags to apply when setting the form.
     * @returns {Promise} - The promise that is triggered when the form is set.
     */
    setForm(form, flags = {}) {
        var _a;
        const isFormAlreadySet = this._form && ((_a = this._form.components) === null || _a === void 0 ? void 0 : _a.length);
        try {
            // Do not set the form again if it has been already set
            if (isFormAlreadySet && JSON.stringify(this._form) === JSON.stringify(form)) {
                this.formReadyResolve();
                return Promise.resolve();
            }
            // Create the form.
            this._form = (flags === null || flags === void 0 ? void 0 : flags.keepAsReference) ? form : lodash_1.default.cloneDeep(form);
            if (this.onSetForm) {
                this.onSetForm(lodash_1.default.cloneDeep(this._form), form);
            }
        }
        catch (err) {
            // If provided form is not a valid JSON object, do not set it too
            this.formReadyReject(err);
            return Promise.resolve();
        }
        // Allow the form to provide component overrides.
        if (form && form.settings && form.settings.components) {
            this.options.components = form.settings.components;
        }
        if (form && form.properties) {
            this.options.properties = form.properties;
        }
        // Use the sanitize config from the form settings or the global sanitize config if it is not provided in the options
        if (!this.options.sanitizeConfig && !this.builderMode) {
            this.options.sanitizeConfig =
                lodash_1.default.get(form, "settings.sanitizeConfig") ||
                    lodash_1.default.get(form, "globalSettings.sanitizeConfig");
        }
        if ("schema" in form && (0, compare_versions_1.compareVersions)(form.schema, "1.x") > 0) {
            this.ready.then(() => {
                this.setAlert("alert alert-danger", "Form schema is for a newer version, please upgrade your renderer. Some functionality may not work.");
            });
        }
        // See if they pass a module, and evaluate it if so.
        if (form && form.module) {
            let formModule = null;
            if (typeof form.module === "string") {
                try {
                    formModule = this.evaluate(`return ${form.module}`);
                }
                catch (err) {
                    console.warn(err);
                }
            }
            else {
                formModule = form.module;
            }
            if (formModule) {
                AriForm_1.AriForm.use(formModule);
                // Since we got here after instantiation, we need to manually apply form options.
                if (formModule.options && formModule.options.form) {
                    this.options = Object.assign(this.options, formModule.options.form);
                }
            }
        }
        this.initialized = false;
        const rebuild = this.rebuild() || Promise.resolve();
        return rebuild.then(() => {
            this.emit("formLoad", form);
            this.triggerCaptcha();
            // Make sure to trigger onChange after a render event occurs to speed up form rendering.
            setTimeout(() => {
                this.onChange(flags);
                this.formReadyResolve();
            }, 0);
            return this.formReady;
        });
    }
    /**
     * Gets the form object.
     * @returns {object} - The form JSON schema.
     */
    get form() {
        if (!this._form) {
            this._form = {
                components: [],
            };
        }
        return this._form;
    }
    /**
     * Sets the form value.
     * @alias setForm
     * @param {object} form - The form schema object.
     */
    set form(form) {
        this.setForm(form);
    }
    /**
     * Returns the submission object that was set within this form.
     * @returns {object} - The submission object.
     */
    get submission() {
        return this.getValue();
    }
    /**
     * Sets the submission of a form.
     * @example
     * import Webform from '@ariform/js/Webform';
     * let form = new Webform(document.getElementById('ariform'));
     * form.src = 'https://examples.ari.form/example';
     * form.submission = {data: {
     *   firstName: 'Joe',
     *   lastName: 'Smith',
     *   email: 'joe@example.com'
     * }};
     * @param {object} submission - The Ari.Form submission object.
     */
    set submission(submission) {
        this.setSubmission(submission);
    }
    /**
     * Sets the submission value
     * @param {object|null|undefined} submission - The submission to set.
     * @param {object|null|undefined} flags - Any flags to apply when setting the submission.
     * @returns {void}
     */
    onSetSubmission(submission, flags = {}) {
        this.submissionSet = true;
        this.triggerChange(flags);
        this.emit('beforeSetSubmission', submission);
        this.setValue(submission, flags);
    }
    /**
     * Sets a submission and returns the promise when it is ready.
     * @param {any} submission - The submission to set.
     * @param {any} flags - Any flags to apply when setting the submission.
     * @returns {Promise} - The promise that is triggered when the submission is set.
     */
    setSubmission(submission, flags = {}) {
        flags = Object.assign(Object.assign({}, flags), { fromSubmission: lodash_1.default.has(flags, "fromSubmission") ? flags.fromSubmission : true });
        return (this.onSubmission = this.formReady
            .then((resolveFlags) => {
            if (resolveFlags) {
                flags = Object.assign(Object.assign({}, flags), resolveFlags);
            }
            this.onSetSubmission(submission, flags);
            return this.submissionReadyResolve(submission);
        }, (err) => this.submissionReadyReject(err))
            .catch((err) => this.submissionReadyReject(err)));
    }
    handleDraftError(errName, errDetails, restoreDraft) {
        const errorMessage = lodash_1.default.trim(`${this.t(errName)} ${errDetails || ""}`);
        this.emit(restoreDraft ? "restoreDraftError" : "saveDraftError", errDetails || errorMessage);
    }
    saveDraft() {
        if (!this.draftEnabled) {
            return;
        }
        if (!this.ariform) {
            this.handleDraftError("saveDraftInstanceError");
            return;
        }
        if (!AriForm_1.AriForm.getUser()) {
            this.handleDraftError("saveDraftAuthError");
            return;
        }
        const draft = (0, utils_1.fastCloneDeep)(this.submission);
        draft.state = "draft";
        if (!this.savingDraft && !this.submitting) {
            this.emit("saveDraftBegin");
            this.savingDraft = true;
            this.ariform
                .saveSubmission(draft)
                .then((sub) => {
                // Set id to submission to avoid creating new draft submission
                this.submission._id = sub._id;
                this.savingDraft = false;
                this.emit("saveDraft", sub);
            })
                .catch((err) => {
                this.savingDraft = false;
                this.handleDraftError("saveDraftError", err);
            });
        }
    }
    /**
     * Restores a draft submission based on the user who is authenticated.
     * @param {string} userId - The user id where we need to restore the draft from.
     */
    restoreDraft(userId) {
        const ariform = this.ariform || this.options.ariform;
        if (!ariform) {
            this.handleDraftError("restoreDraftInstanceError", null, true);
            return;
        }
        this.savingDraft = true;
        ariform
            .loadSubmissions({
            params: {
                state: 'draft',
                owner: userId,
                sort: '-created'
            },
        })
            .then((submissions) => {
            if (submissions.length > 0 && !this.options.skipDraftRestore) {
                const draft = (0, utils_1.fastCloneDeep)(submissions[0]);
                return this.setSubmission(draft).then(() => {
                    this.draftEnabled = true;
                    this.savingDraft = false;
                    this.emit("restoreDraft", draft);
                });
            }
            // Enable drafts so that we can keep track of changes.
            this.draftEnabled = true;
            this.savingDraft = false;
            this.emit("restoreDraft", null);
        })
            .catch((err) => {
            this.draftEnabled = true;
            this.savingDraft = false;
            this.handleDraftError("restoreDraftError", err, true);
        });
    }
    get schema() {
        const schema = (0, utils_1.fastCloneDeep)(lodash_1.default.omit(this._form, ["components"]));
        schema.components = [];
        this.eachComponent((component) => schema.components.push(component.schema));
        return schema;
    }
    mergeData(_this, _that) {
        lodash_1.default.mergeWith(_this, _that, (thisValue, thatValue) => {
            if (Array.isArray(thisValue) &&
                Array.isArray(thatValue) &&
                thisValue.length !== thatValue.length) {
                return thatValue;
            }
        });
    }
    setValue(submission, flags = {}) {
        if (!submission || !submission.data) {
            submission = {
                data: {},
            };
        }
        // Metadata needs to be available before setValue
        this._submission.metadata = submission.metadata ? lodash_1.default.cloneDeep(submission.metadata) : {};
        this.editing = !!submission._id;
        // Set the timezone in the options if available.
        if (!this.options.submissionTimezone &&
            submission.metadata &&
            submission.metadata.timezone) {
            this.options.submissionTimezone = submission.metadata.timezone;
        }
        const changed = super.setValue(submission.data, flags);
        if (!flags.sanitize) {
            this.mergeData(this.data, submission.data);
        }
        submission.data = this.data;
        this._submission = submission;
        return changed;
    }
    getValue() {
        if (!this._submission) {
            this._submission = {};
        }
        if (!this._submission.data) {
            this._submission.data = {};
        }
        if (this.viewOnly) {
            return this._submission;
        }
        const submission = this._submission;
        submission.data = this.data;
        return this._submission;
    }
    /**
     * Build the form.
     * @returns {Promise} - The promise that is triggered when the form is built.
     */
    init() {
        if (this.options.submission) {
            const submission = lodash_1.default.extend({}, this.options.submission);
            this._submission = submission;
            this._data = submission.data;
        }
        else {
            this._submission = this._submission || { data: {} };
        }
        // Remove any existing components.
        if (this.components && this.components.length) {
            this.destroyComponents();
            this.components = [];
        }
        if (this.component) {
            this.component.components = this.form ? this.form.components : [];
        }
        else {
            this.component = this.form;
        }
        this.component.type = "form";
        this.component.input = false;
        this.addComponents();
        this.on("submitButton", (options) => {
            this.submit(false, options).catch((e) => {
                options.instance.loading = false;
                return e !== false && e !== undefined && console.log(e);
            });
        }, true);
        this.on("checkValidity", (data) => this.validate(data, { dirty: true, process: "change" }), true);
        this.on("requestUrl", (args) => this.submitUrl(args.url, args.headers), true);
        this.on("resetForm", () => this.resetValue(), true);
        this.on("deleteSubmission", () => this.deleteSubmission(), true);
        this.on("refreshData", () => this.updateValue(), true);
        //Simple
        this.on('requestAri', (args) => (this.submitAri(args.com, args.url, args.aribody, args.resultType, args.args, args.script, args.scriptFail)), true);
        this.on('redirectPage', (args) => (this.redirectPage(args.url, args.paramGet, args.paramPost, args.openNewTab, args.form, args.redirectToStaticPage)), true);
        this.registerHttpOnErrorEvent();
        //End Simple
        this.executeFormController();
        return this.formReady;
    }
    //Simple
    registerHttpOnErrorEvent() {
        //440
        AriForm_1.AriForm.events.on('ariform.sessionExpired', (responseBody) => {
            this.onSessionExpired(responseBody);
        });
        //401
        AriForm_1.AriForm.events.on('ariform.unauthorized', (responseBody) => {
            this.onUnauthorized(responseBody);
        });
        //403
        AriForm_1.AriForm.events.on('ariform.forbidden', (responseBody) => {
            this.onUnauthorized(responseBody);
        });
        //Other Error
        AriForm_1.AriForm.events.on('ariform.otherHttpError', (response) => {
            this.onOtherHttpError(response);
        });
    }
    onSessionExpired(responseBody) {
        if ((0, utils_1.getVariable)('token') !== undefined && (0, utils_1.getVariable)('token') !== '' && (0, utils_1.getVariable)('token') !== null) {
            document.querySelector('.popup-notice-exp').classList.add('active');
        }
        else {
            (0, utils_1.setVariable)('token');
            window.location.href = (0, utils_2.formatUrl)((0, utils_1.getParamConfig)('REACT_APP_LOGIN_PAGE'));
        }
    }
    onUnauthorized(responseBody) {
        if ((0, utils_1.getVariable)('token') !== undefined && (0, utils_1.getVariable)('token') !== '' && (0, utils_1.getVariable)('token') !== null) {
            document.querySelector('.popup-notice-exp').classList.add('active');
        }
        else {
            (0, utils_1.setVariable)('token');
            window.location.href = (0, utils_2.formatUrl)((0, utils_1.getParamConfig)('REACT_APP_LOGIN_PAGE'));
        }
    }
    onForbidden(responseBody) {
        window.location.replace((0, utils_2.formatUrl)((0, utils_1.getParamConfig)('REACT_APP_ACCESS_DENY_PAGE')));
    }
    onOtherHttpError(response) {
        console.log(response.status);
    }
    //End Simple
    executeFormController() {
        // If no controller value or
        // hidden and set to clearOnHide (Don't calculate a value for a hidden field set to clear when hidden)
        if (!this.form ||
            !this.form.controller ||
            ((!this.visible || this.component.hidden) &&
                this.component.clearOnHide &&
                !this.rootPristine)) {
            return false;
        }
        this.formReady.then(() => {
            this.evaluate(this.form.controller, {
                components: this.components,
                instance: this,
            });
        });
    }
    /**
     *
     */
    teardown() {
        this.emit("formDelete", this.id);
        delete AriForm_1.AriForm.forms[this.id];
        delete this.executeShortcuts;
        delete this.triggerSaveDraft;
        super.teardown();
    }
    destroy(all = false) {
        this.off("submitButton");
        this.off("checkValidity");
        this.off("requestUrl");
        this.off("resetForm");
        this.off("deleteSubmission");
        this.off("refreshData");
        //Simple
        this.off("requestAri");
        this.off("refreshData");
        //End Simple
        return super.destroy(all);
    }
    build(element) {
        if (element || this.element) {
            return this.ready.then(() => {
                element = element || this.element;
                super.build(element);
            });
        }
        return this.ready;
    }
    getClassName() {
        let classes = "ariform-form";
        if (this.options.readOnly) {
            classes += " ariform-read-only";
        }
        return classes;
    }
    render() {
        return super.render(this.renderTemplate("webform", {
            classes: this.getClassName(),
            children: this.renderComponents(),
        }), this.builderMode ? "builder" : "form", true);
    }
    redraw() {
        // Don't bother if we have not built yet.
        if (!this.element) {
            return Promise.resolve();
        }
        this.clear();
        this.setContent(this.element, this.render());
        return this.attach(this.element);
    }
    attach(element) {
        this.setElement(element);
        this.loadRefs(element, { webform: "single" });
        const childPromise = this.attachComponents(this.refs.webform);
        this.addEventListener(document, "keydown", this.executeShortcuts);
        this.currentForm = this;
        this.hook("attachWebform", element, this);
        return childPromise.then(() => {
            this.emit("render", this.element);
            return this.setValue(this._submission, {
                noUpdateEvent: true,
            });
        });
    }
    hasRequiredFields() {
        let result = false;
        (0, formUtils_1.eachComponent)(this.form.components, (component) => {
            if (component.validate.required) {
                result = true;
                return true;
            }
        }, true);
        return result;
    }
    resetValue() {
        lodash_1.default.each(this.getComponents(), (comp) => comp.resetValue());
        this.setPristine(true);
        this.onChange({ resetValue: true });
    }
    /**
     * Sets a new alert to display in the error dialog of the form.
     * @param {string} type - The type of alert to display. "danger", "success", "warning", etc.
     * @param {string} message - The message to show in the alert.
     * @param {object} options - The options for the alert.
     */
    setAlert(type, message, options) {
        //Simple
        switch (type) {
            case 'success':
                (0, utils_2.toastsuccess)('', message, options);
                break;
            case 'warning':
                (0, utils_2.toastwarning)('', message, options);
                break;
            case 'danger':
                (0, utils_2.toasterror)('', message, options);
                break;
            default:
                (0, utils_2.toast)(message, options);
                break;
        }
        return;
        //SimpleToDo: check how it work
        //End Simple
        if (!type && this.submitted) {
            if (this.alert) {
                if (this.refs.errorRef && this.refs.errorRef.length) {
                    this.refs.errorRef.forEach((el) => {
                        this.removeEventListener(el, "click");
                        this.removeEventListener(el, "keypress");
                    });
                }
                this.removeChild(this.alert);
                this.alert = null;
            }
            return;
        }
        if (this.options.noAlerts) {
            if (!message) {
                this.emit("error", false);
            }
            return;
        }
        if (this.alert) {
            try {
                if (this.refs.errorRef && this.refs.errorRef.length) {
                    this.refs.errorRef.forEach((el) => {
                        this.removeEventListener(el, "click");
                        this.removeEventListener(el, "keypress");
                    });
                }
                this.removeChild(this.alert);
                this.alert = null;
            }
            catch (err) {
                // ignore
            }
        }
        if (message) {
            const attrs = {
                class: (options && options.classes) || `alert alert-${type}`,
                id: `error-list-${this.id}`,
            };
            const templateOptions = {
                message: message instanceof HTMLElement ? message.outerHTML : message,
                attrs: attrs,
                type,
            };
            this.alert = (0, utils_1.convertStringToHTMLElement)(this.renderTemplate("alert", templateOptions), `#${attrs.id}`);
        }
        if (!this.alert) {
            return;
        }
        this.loadRefs(this.alert, { errorRef: "multiple" });
        if (this.refs.errorRef && this.refs.errorRef.length) {
            this.refs.errorRef.forEach((el) => {
                this.addEventListener(el, "click", (e) => {
                    const key = e.currentTarget.dataset.componentKey;
                    this.focusOnComponent(key);
                });
                this.addEventListener(el, "keydown", (e) => {
                    if (e.keyCode === 13) {
                        e.preventDefault();
                        const key = e.currentTarget.dataset.componentKey;
                        this.focusOnComponent(key);
                    }
                });
            });
        }
        this.prepend(this.alert);
    }
    /**
     * Focus on selected component.
     * @param {string} key - The key of selected component.
     */
    focusOnComponent(key) {
        if (key) {
            const component = this.getComponent(key);
            if (component) {
                component.focus();
            }
        }
    }
    /**
     * Show the errors of this form within the alert dialog.
     * @param {object} error - An optional additional error to display along with the component errors.
     * @returns {*}
     */
    /* eslint-disable no-unused-vars */
    /**
     *
     * @param {Array} errors - An array of errors to display.
     * @param {boolean} triggerEvent - Whether or not to trigger the error event.
     * @returns {void|Array} - The errors that were set.
     */
    showErrors(errors, triggerEvent) {
        this.loading = false;
        if (!Array.isArray(errors)) {
            errors = [errors];
        }
        if (Array.isArray(this.errors)) {
            errors = lodash_1.default.union(errors, this.errors);
        }
        errors = errors.concat(this.customErrors).filter((err) => !!err);
        if (!errors.length) {
            this.setAlert(false);
            return;
        }
        // Mark any components as invalid if in a custom message.
        const componentErrors = {};
        errors.forEach((err) => {
            var _a, _b;
            const path = err.path || ((_a = err.context) === null || _a === void 0 ? void 0 : _a.path) || ((_b = err.component) === null || _b === void 0 ? void 0 : _b.key);
            if (!componentErrors[path]) {
                componentErrors[path] = [];
            }
            componentErrors[path].push(err);
        });
        // Iterate through all of our component errors and apply them to the components.
        for (let path in componentErrors) {
            const component = this.getComponent(path);
            const errors = componentErrors[path];
            if (component) {
                component.serverErrors = errors.filter((err) => err.fromServer);
                component.setCustomValidity(errors, true);
            }
        }
        const displayedErrors = [];
        if (errors.length) {
            errors = lodash_1.default.uniqBy(errors, (error) => { var _a, _b; return [error.message, (_a = error.component) === null || _a === void 0 ? void 0 : _a.id, (_b = error.context) === null || _b === void 0 ? void 0 : _b.path].join(); });
            const createListItem = (message, index) => {
                var _a, _b, _c;
                const err = errors[index];
                const messageFromIndex = !lodash_1.default.isUndefined(index) && errors && errors[index];
                const keyOrPath = (messageFromIndex === null || messageFromIndex === void 0 ? void 0 : messageFromIndex.formattedKeyOrPath) ||
                    (messageFromIndex === null || messageFromIndex === void 0 ? void 0 : messageFromIndex.path) ||
                    ((_a = messageFromIndex === null || messageFromIndex === void 0 ? void 0 : messageFromIndex.context) === null || _a === void 0 ? void 0 : _a.path) ||
                    (((_b = err.context) === null || _b === void 0 ? void 0 : _b.component) && ((_c = err.context) === null || _c === void 0 ? void 0 : _c.component.key)) ||
                    (err.component && err.component.key) ||
                    (err.fromServer && err.path);
                const formattedKeyOrPath = keyOrPath ? (0, utils_1.getStringFromComponentPath)(keyOrPath) : "";
                if (typeof err !== "string" && !err.formattedKeyOrPath) {
                    err.formattedKeyOrPath = formattedKeyOrPath;
                }
                return {
                    message: (0, utils_1.unescapeHTML)(message),
                    keyOrPath: formattedKeyOrPath,
                };
            };
            errors.forEach(({ message, context, fromServer, component }, index) => {
                const text = !(component === null || component === void 0 ? void 0 : component.label) || (context === null || context === void 0 ? void 0 : context.hasLabel) || fromServer
                    ? this.t("alertMessage", { message: this.t(message) })
                    : this.t("alertMessageWithLabel", {
                        label: this.t(component === null || component === void 0 ? void 0 : component.label),
                        message: this.t(message),
                    });
                displayedErrors.push(createListItem(text, index));
            });
        }
        const errorsList = this.renderTemplate("errorsList", { errors: displayedErrors });
        this.root.setAlert("danger", errorsList);
        if (triggerEvent) {
            this.emit("error", errors);
        }
        return errors;
    }
    /* eslint-enable no-unused-vars */
    /**
     * Called when the submission has completed, or if the submission needs to be sent to an external library.
     * @param {object} submission - The submission object.
     * @param {boolean} saved - Whether or not this submission was saved to the server.
     * @returns {object} - The submission object.
     */
    onSubmit(submission, saved) {
        var _a;
        this.loading = false;
        this.submitting = false;
        this.setPristine(true);
        // We want to return the submitted submission and setValue will mutate the submission so cloneDeep it here.
        this.setValue((0, utils_1.fastCloneDeep)(submission), {
            noValidate: true,
            noCheck: true,
        });
        this.setAlert("success", `<p>${this.t("complete")}</p>`);
        // Cancel triggered saveDraft to prevent overriding the submitted state
        if (this.draftEnabled && ((_a = this.triggerSaveDraft) === null || _a === void 0 ? void 0 : _a.cancel)) {
            this.triggerSaveDraft.cancel();
        }
        this.emit("submit", submission, saved);
        if (saved) {
            this.emit("submitDone", submission);
        }
        return submission;
    }
    normalizeError(error) {
        if (error) {
            if (typeof error === "object" && "details" in error) {
                error = error.details;
            }
            if (typeof error === "string") {
                error = { message: error };
            }
        }
        return error;
    }
    /**
     * Called when an error occurs during the submission.
     * @param {object} error - The error that occured.
     * @returns {Array} errors - All errors.
     */
    onSubmissionError(error) {
        error = this.normalizeError(error);
        this.submitting = false;
        this.setPristine(false);
        this.emit("submitError", error || this.errors);
        // Allow for silent cancellations (no error message, no submit button error state)
        if (error && error.silent) {
            this.emit("change", { isValid: true }, { silent: true });
            return false;
        }
        const errors = this.showErrors(error, true);
        if (this.root && this.root.alert) {
            this.scrollIntoView(this.root.alert);
        }
        return errors;
    }
    /**
     * Trigger the change event for this form.
     * @param {any} flags - The flags to set on this change event.
     * @param {any} changed - The changed object which reflects the changes in the form.
     * @param {boolean} modified - Whether or not the form has been modified.
     * @param {any} changes - The changes that have occured in the form.
     */
    onChange(flags, changed, modified, changes) {
        var _a;
        flags = flags || {};
        let isChangeEventEmitted = false;
        if (((_a = this.parent) === null || _a === void 0 ? void 0 : _a.subForm) === this) {
            super.onChange(Object.assign(Object.assign({}, flags), { modified }), false);
        }
        else {
            super.onChange(flags, true);
        }
        const value = lodash_1.default.clone(this.submission);
        flags.changed = value.changed = changed;
        flags.changes = changes;
        if (modified && this.pristine) {
            this.pristine = false;
        }
        this.checkData(value.data, flags);
        const shouldValidate = !flags.noValidate ||
            flags.fromIframe ||
            (flags.fromSubmission && this.rootPristine && this.pristine && flags.changed);
        const errors = shouldValidate
            ? this.validate(value.data, Object.assign(Object.assign({}, flags), { noValidate: false, process: 'change' }))
            : [];
        value.isValid = (errors || []).filter(err => !err.fromServer).length === 0;
        this.loading = false;
        if (this.submitted) {
            // show server errors while they are not cleaned/fixed
            const nonComponentServerErrors = lodash_1.default.filter(this.serverErrors || [], (err) => !err.component && !err.path);
            this.showErrors(nonComponentServerErrors.length ? nonComponentServerErrors : errors);
        }
        // See if we need to save the draft of the form.
        if (modified && this.options.saveDraft) {
            this.triggerSaveDraft();
        }
        if (!flags || !flags.noEmit) {
            this.emit("change", value, flags, modified);
            isChangeEventEmitted = true;
        }
        // The form is initialized after the first change event occurs.
        if (isChangeEventEmitted && !this.initialized) {
            this.emit("initialized");
            this.initialized = true;
        }
    }
    /**
     * Send a delete request to the server.
     * @returns {Promise} - The promise that is triggered when the delete is complete.
     */
    deleteSubmission() {
        return this.ariform.deleteSubmission().then(() => {
            this.emit("submissionDeleted", this.submission);
            this.resetValue();
        });
    }
    /**
     * Cancels the submission.
     * @param {boolean} noconfirm - Whether or not to confirm the cancellation.
     * @alias reset
     * @returns {boolean} - TRUE means the submission was cancelled, FALSE otherwise.
     */
    cancel(noconfirm) {
        const shouldReset = this.hook("beforeCancel", true);
        if (shouldReset && (noconfirm || confirm(this.t("confirmCancel")))) {
            this.resetValue();
            return true;
        }
        else {
            this.emit("cancelSubmit");
            return false;
        }
    }
    setMetadata(submission) {
        // Add in metadata about client submitting the form
        submission.metadata = submission.metadata || {};
        lodash_1.default.defaults(submission.metadata, {
            timezone: lodash_1.default.get(this, "_submission.metadata.timezone", (0, utils_1.currentTimezone)()),
            offset: parseInt(lodash_1.default.get(this, "_submission.metadata.offset", (0, moment_1.default)().utcOffset()), 10),
            origin: document.location.origin,
            referrer: document.referrer,
            browserName: navigator.appName,
            userAgent: navigator.userAgent,
            pathName: window.location.pathname,
            onLine: navigator.onLine,
        });
    }
    submitForm(options = {}, local = false) {
        this.clearServerErrors();
        // hungnq 
        const ariHeader = AriFormUtils.getVariable('clientInfo') ? AriFormUtils.getVariable('clientInfo') : AriFormUtils.getClientInfo();
        const ariLang = AriFormUtils.getVariable('BlazorCulture') || 'en-US';
        // end hungnq
        return new Promise((resolve, reject) => {
            // Read-only forms should never submit.
            if (this.options.readOnly) {
                return resolve({
                    submission: this.submission,
                    saved: false,
                });
            }
            const submission = (0, utils_1.fastCloneDeep)(this.submission || {});
            this.setMetadata(submission);
            submission.state = options.state || submission.state || "submitted";
            const isDraft = submission.state === "draft";
            this.hook("beforeSubmit", Object.assign(Object.assign({}, submission), { component: options.component }), (err, data) => {
                var _a;
                if (err) {
                    return reject(err);
                }
                submission._vnote = data && data._vnote ? data._vnote : "";
                try {
                    if (!isDraft && !options.noValidate) {
                        if (!submission.data) {
                            return reject("Invalid Submission");
                        }
                        const errors = this.validate(submission.data, {
                            local,
                            dirty: true,
                            silentCheck: false,
                            process: "submit",
                        });
                        if (errors.length ||
                            ((_a = options.beforeSubmitResults) === null || _a === void 0 ? void 0 : _a.some((result) => result.status === "rejected"))) {
                            return reject(errors);
                        }
                    }
                }
                catch (err) {
                    console.error(err);
                }
                this.everyComponent((comp) => {
                    var _a, _b;
                    if (submission._vnote && comp.type === "form" && comp.component.reference) {
                        lodash_1.default.get(submission.data, local ? (_a = comp.paths) === null || _a === void 0 ? void 0 : _a.localDataPath : comp.path, {})._vnote = submission._vnote;
                    }
                    const { persistent } = comp.component;
                    if (persistent === "client-only") {
                        lodash_1.default.unset(submission.data, local ? (_b = comp.paths) === null || _b === void 0 ? void 0 : _b.localDataPath : comp.path);
                    }
                });
                this.hook("customValidation", Object.assign(Object.assign({}, submission), { component: options.component }), (err) => {
                    if (err) {
                        // If string is returned, cast to object.
                        if (typeof err === "string") {
                            err = {
                                message: err,
                            };
                        }
                        // Ensure err is an array.
                        err = Array.isArray(err) ? err : [err];
                        return reject(err);
                    }
                    this.loading = true;
                    // Use the form action to submit the form if available.
                    if (this._form && this._form.action) {
                        const method = submission.data._id &&
                            this._form.action.includes(submission.data._id)
                            ? "PUT"
                            : "POST";
                        // Hungnq
                        AriFormUtils.handleCAllAPI(this._form.action, method, submission, {}, (responseData) => {
                            if (responseData) {
                                return resolve({
                                    submission: responseData,
                                    saved: true,
                                });
                            }
                        }, (error) => {
                            this.setServerErrors(error);
                            return reject(error);
                        });
                        // end Hungnq 
                    }
                    const submitAriForm = this.ariform;
                    if (this.nosubmit || !submitAriForm) {
                        return resolve({
                            submission,
                            saved: false,
                        });
                    }
                    // If this is an actionUrl, then make sure to save the action and not the submission.
                    const submitMethod = submitAriForm.actionUrl
                        ? "saveAction"
                        : "saveSubmission";
                    submitAriForm[submitMethod](submission)
                        .then((result) => resolve({
                        submission: result,
                        saved: true,
                    }))
                        .catch((error) => {
                        this.setServerErrors(error);
                        return reject(error);
                    });
                });
            });
        });
    }
    setServerErrors(error) {
        if (error.details) {
            this.serverErrors = error.details
                .filter((err) => (err.level ? err.level === "error" : err))
                .map((err) => {
                err.fromServer = true;
                return err;
            });
        }
        else if (typeof error === "string") {
            this.serverErrors = [{ fromServer: true, level: "error", message: error }];
        }
    }
    executeSubmit(options) {
        this.submitted = true;
        this.submitting = true;
        return this.submitForm(options)
            .then(({ submission, saved }) => this.onSubmit(submission, saved))
            .then((results) => {
            this.submissionInProcess = false;
            return results;
        })
            .catch((err) => {
            this.submissionInProcess = false;
            return Promise.reject(this.onSubmissionError(err));
        });
    }
    clearServerErrors() {
        var _a;
        (_a = this.serverErrors) === null || _a === void 0 ? void 0 : _a.forEach((error) => {
            if (error.path) {
                const pathArray = (0, utils_1.getArrayFromComponentPath)(error.path);
                const component = this.getComponent(pathArray, lodash_1.default.identity, error.formattedKeyOrPath);
                if (component) {
                    component.serverErrors = [];
                }
            }
        });
        this.serverErrors = [];
    }
    /**
     * Submits the form.
     * @example
     * import Webform from '@ariform/js/Webform';
     * let form = new Webform(document.getElementById('ariform'));
     * form.src = 'https://examples.ari.form/example';
     * form.submission = {data: {
     *   firstName: 'Joe',
     *   lastName: 'Smith',
     *   email: 'joe@example.com'
     * }};
     * form.submit().then((submission) => {
     *   console.log(submission);
     * });
     * @param {boolean} before - If this submission occured from the before handlers.
     * @param {any} options - The options to use when submitting this form.
     * @returns {Promise} - A promise when the form is done submitting.
     */
    submit(before = false, options = {}) {
        this.submissionInProcess = true;
        if (!before) {
            return this.beforeSubmit(options).then(() => this.executeSubmit(options));
        }
        else {
            return this.executeSubmit(options);
        }
    }
    submitUrl(URL, headers) {
        if (!URL) {
            return console.warn("Missing URL argument");
        }
        // hungnq
        const ariHeader = AriFormUtils.getVariable('clientInfo') ? AriFormUtils.getVariable('clientInfo') : AriFormUtils.getClientInfo();
        const ariLang = AriFormUtils.getVariable('BlazorCulture') || 'en-US';
        const submission = this.submission || {};
        const API_URL = URL;
        const settings = {
            method: "POST",
            headers: { "Ari-ClientInfo": ariHeader, "Ari-Lang": ariLang },
        };
        // end hungnq 
        if (headers && headers.length > 0) {
            headers.map((e) => {
                if (e.header !== "" && e.value !== "") {
                    settings.headers[e.header] = this.interpolate(e.value, submission);
                }
            });
        }
        if (API_URL && settings) {
            // hungnq 
            AriForm_1.AriForm.handleCAllAPI(API_URL, settings.method, submission, settings.headers, () => {
                this.emit("requestDone");
                this.setAlert("success", "<p> Success </p>");
            }, (responseData) => {
                const message = responseData === null || responseData === void 0 ? void 0 : responseData.responseDesc;
                this.emit("error", message);
                this.setAlert("danger", `<p> ${message} </p>`);
                return Promise.reject(this.onSubmissionError(responseData));
            });
            // hungnq 
        }
        else {
            this.emit("error", "You should add a URL to this button.");
            this.setAlert("warning", "You should add a URL to this button.");
            return console.warn("You should add a URL to this button.");
        }
    }
    triggerCaptcha() {
        if (!this || !this.components) {
            return;
        }
        const captchaComponent = [];
        this.eachComponent((component) => {
            if (/^(re)?captcha$/.test(component.type) && component.component.eventType === 'formLoad') {
                captchaComponent.push(component);
            }
        });
        if (captchaComponent.length > 0) {
            captchaComponent[0].verify(`${this.form.name ? this.form.name : 'form'}Load`);
        }
    }
    set nosubmit(value) {
        this._nosubmit = !!value;
        this.emit("nosubmit", this._nosubmit);
    }
    get nosubmit() {
        return this._nosubmit || false;
    }
    get conditions() {
        var _a, _b;
        return (_b = (_a = this.schema.settings) === null || _a === void 0 ? void 0 : _a.conditions) !== null && _b !== void 0 ? _b : [];
    }
    get variables() {
        var _a, _b;
        return (_b = (_a = this.schema.settings) === null || _a === void 0 ? void 0 : _a.variables) !== null && _b !== void 0 ? _b : [];
    }
    //Simple
    submitAri(com, URL, aribody, resultType, args, script, scriptFail) {
        this.emit('postAriStart', args.component.id);
        if (!URL) {
            return console.warn("Missing URL argument");
        }
        const submission = this.submission || {};
        var API_URL = AriForm_1.AriForm.baseUrl;
        if (!(URL.startsWith(AriForm_1.AriForm.serviceId.toLowerCase()))) {
            API_URL += `/${AriForm_1.AriForm.serviceId.toLowerCase()}`;
        }
        API_URL += `/${URL}`;
        // hungnq 
        const ariHeader = AriFormUtils.getVariable('clientInfo') ? AriFormUtils.getVariable('clientInfo') : AriFormUtils.getClientInfo();
        const ariLang = AriFormUtils.getVariable('BlazorCulture') || 'en-US';
        // end hungnq 
        const settings = {
            method: "POST",
            headers: {
                'Content-type': AriForm_1.AriForm.encryptRequest ? 'text/plain' : 'application/json',
                'Authorization': (0, utils_1.getVariable)('token'),
                // hungnq 
                "Ari-ClientInfo": ariHeader,
                "Ari-Lang": ariLang
                // end hungnq
            },
            body: {
            // "tokenInfo": {
            //     "channelId": "MB",
            //     "ctmLicenseNo": null,
            //     "ctmCif": "11000900"
            // }
            }
        };
        if (aribody && aribody.length > 0) {
            aribody.map((e) => {
                lodash_1.default.set(settings.body, e.path, this.setValueByType(e, submission, args), settings.body);
            });
        }
        const form = this.getRoot();
        const flattened = this.flattenComponents(form.component.components, true);
        const components = {};
        lodash_1.default.each(flattened, (component, key) => {
            const element = form.getComponent(key);
            if (element) {
                components[key] = element;
            }
        });
        // if (headers && headers.length > 0) {
        //     headers.map((e) => {
        //         if (e.header !== "" && e.value !== "") {
        //             settings.headers[e.header] = this.interpolate(e.value, submission);
        //         }
        //     });
        // }
        const handleSuccessSubmitAri = (result) => {
            this.emit('postAriDone', args.component.id);
            this.emit("requestDone");
            if (resultType && resultType !== 'none') {
                var options = {
                    'positionClass': resultType
                };
                this.setAlert('success', 'Transaction was completed successfully', options);
            }
            if (com.ariOnSucess) {
                this.evaluate(com.ariOnSucess, {
                    form,
                    flattened,
                    components,
                    result
                });
            }
            if (script) {
                script(result);
            }
        };
        const handleErrorSubmitAri = (e) => {
            this.handleRequestError(URL, e === null || e === void 0 ? void 0 : e.response, e === null || e === void 0 ? void 0 : e.opts);
            if (scriptFail && (!!e)) {
                scriptFail(e.error ? AriFormUtils.decryptResponse(e.error) : '');
            }
            try {
                this.emit('postAriDone', args.component.id);
                //this.emit('error');
                if (resultType && resultType !== 'none') {
                    var options = {
                        'positionClass': resultType
                    };
                    if (e.responseCode && e.responseDesc) {
                        this.setAlert('danger', `<p> [${e.responseCode ? e.responseCode.toUpperCase() : ''}] ${e.responseDesc ? e.responseDesc : e} </p><p>InstanceId: ${e.workflowInstanceId ? e.workflowInstanceId : ''}</p>`, options);
                    }
                    else {
                        this.setAlert('danger', `<p> [${e.responseCode ? e.responseCode.toUpperCase() : ''}] ${e.responseDesc ? e.responseDesc : e} </p><p>InstanceId: ${e.workflowInstanceId ? e.workflowInstanceId : ''}</p>`, options);
                    }
                }
            }
            catch (ex) {
                this.setAlert('danger', `<p>${ex}</p>`, options);
            }
            if (com.ariOnFail) {
                if (e.response && e.response.status == 401 && URL !== 'internal/token')
                    return;
                this.evaluate(com.ariOnFail, {
                    form,
                    flattened,
                    components,
                    result: AriFormUtils.decryptResponse(e.error) || AriFormUtils.decryptResponse(e)
                });
            }
        };
        if (API_URL && settings) {
            AriFormUtils.handleCAllAPI(API_URL, settings.method, settings.body, settings.headers, (responseData) => { handleSuccessSubmitAri(responseData); }, (err) => { handleErrorSubmitAri(err); });
        }
        else {
            this.emit("error", "You should add a URL to this button.");
            this.setAlert("warning", "You should add a URL to this button.");
        }
    }
    handleRequestError(url, response, opts) {
        var _a, _b;
        if (AriForm_1.AriForm.serviceId === 'MB' && ((_a = response === null || response === void 0 ? void 0 : response.config) === null || _a === void 0 ? void 0 : _a.url) !== `${(0, utils_1.getParamConfig)('REACT_APP_API_URL')}/${AriForm_1.AriForm.serviceId.toLowerCase()}/errorlog`) {
            this.request(`/${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId.toLowerCase()}/errorlog`, 'POST', {
                data: response === null || response === void 0 ? void 0 : response.data,
                url: response === null || response === void 0 ? void 0 : response.config.url,
                status: response === null || response === void 0 ? void 0 : response.status,
                request: response === null || response === void 0 ? void 0 : response.config.data
            });
        }
        //Simple add session exp (request from Hung)
        if ((response === null || response === void 0 ? void 0 : response.status) === 401) {
            if (window.location.pathname !== (0, utils_2.formatUrl)('login')) {
                if (AriForm_1.AriForm === null || AriForm_1.AriForm === void 0 ? void 0 : AriForm_1.AriForm.handleError) {
                    AriForm_1.AriForm === null || AriForm_1.AriForm === void 0 ? void 0 : AriForm_1.AriForm.handleError({
                        errorCode: (response === null || response === void 0 ? void 0 : response.status) || "",
                        oldPath: window.location.pathname
                    });
                }
                else {
                    (0, utils_1.execExternalFunction)('redirectUrl', (0, utils_2.formatUrl)(`login?oldPath=${window.location.pathname}`));
                }
                (0, utils_1.setVariable)('token');
                return false;
            }
            else {
                (0, utils_1.setVariable)('token');
                (0, utils_1.execExternalFunction)('handleError', {
                    errorCode: response === null || response === void 0 ? void 0 : response.status,
                    oldPath: window.location.pathname
                });
                return false;
            }
        }
        else if ((response === null || response === void 0 ? void 0 : response.status) === 403 ||
            ((response === null || response === void 0 ? void 0 : response.status) === 400 && ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.responseCode) === 'sys_access_deny')) {
            if (AriForm_1.AriForm === null || AriForm_1.AriForm === void 0 ? void 0 : AriForm_1.AriForm.handleError) {
                AriForm_1.AriForm === null || AriForm_1.AriForm === void 0 ? void 0 : AriForm_1.AriForm.handleError({
                    errorCode: (response === null || response === void 0 ? void 0 : response.status) || "",
                    oldPath: window.location.pathname
                });
            }
            else {
                (0, utils_1.execExternalFunction)('redirectUrl', (0, utils_2.formatUrl)(`accessdenied`));
            }
            return;
        }
        // eslint-disable-next-line no-dupe-else-if
        else if ((response === null || response === void 0 ? void 0 : response.status) === 403 && (opts === null || opts === void 0 ? void 0 : opts.handleAccessDenied)) {
            opts === null || opts === void 0 ? void 0 : opts.handleAccessDenied(response);
            return false;
        }
        if (opts === null || opts === void 0 ? void 0 : opts.handleError) {
            opts === null || opts === void 0 ? void 0 : opts.handleError(response);
            return false;
        }
        return true;
    }
    redirectPage(url, paramGet, paramPost, openNewTab, form, redirectToStaticPage) {
        const submission = this.submission || {};
        paramGet.map((e, i) => {
            if (e.key && e.key !== '') {
                var value = this.setValueByType(e, submission, form);
                url += i === 0 && !url.includes('?') ? `?${e.key}=${value}` : `&${e.key}=${value}`;
            }
        });
        var result = (0, utils_2.formatUrl)(url);
        if (openNewTab) {
            window.open(redirectToStaticPage && (AriForm_1.AriForm.encryptUrl === "true" || AriForm_1.AriForm.encryptUrl === true) ? `/ari${result}` : result, '_blank').focus();
        }
        else {
            //Fiona
            const redirecFunc = AriForm_1.AriForm.function.find(m => m.functionName === 'redirectUrl');
            if (redirecFunc) {
                redirecFunc.Function(redirectToStaticPage && (AriForm_1.AriForm.encryptUrl === "true" || AriForm_1.AriForm.encryptUrl === true) ? `/ari${result}` : result);
            }
            else {
                window.location.href = redirectToStaticPage && (AriForm_1.AriForm.encryptUrl === "true" || AriForm_1.AriForm.encryptUrl === true) ? `/ari${result}` : result;
            }
            //end Fiona
        }
    }
    setValueByType(e, submission, form) {
        if (form) {
            form.formState = this.formState;
        }
        if (!e.key) {
            e.key = e.path;
        }
        if (e.key) {
            var value = null;
            switch (e.type) {
                case 'script':
                    value = this.evaluate(e.value, form);
                    break;
                case 'data':
                    if (e.value.includes('.')) {
                        var valueObject = submission.data[e.value.split('.')[0]];
                        var path = e.value.substring(e.value.indexOf('.') + 1);
                        value = lodash_1.default.get(valueObject, path);
                    }
                    else {
                        value = submission.data[e.value];
                    }
                    break;
                default:
                    value = e.value;
            }
            return value;
        }
    }
}
exports.default = Webform;
Webform.setBaseUrl = AriForm_1.AriForm.setBaseUrl;
Webform.setApiUrl = AriForm_1.AriForm.setApiUrl;
Webform.setAppUrl = AriForm_1.AriForm.setAppUrl;
